// routes
import { PATH_PAGE } from 'src/routes/paths';
// components
import Iconify from 'src/components/Iconify';

// ----------------------------------------------------------------------

const ICON_SIZE = {
  width: 22,
  height: 22,
};

const menuConfig = [
  {
    title_id: 1,
    title: 'Home',
    icon: <Iconify icon={'eva:home-fill'} {...ICON_SIZE} />,
    path: '/',
  },
  {
    title_id: 2,
    title: 'About',
    icon: <Iconify icon={'ic:round-grain'} {...ICON_SIZE} />,
    path: "#",
    children: [
      {
        subheader: 'About',
        items: [
          { title: 'About us', path: PATH_PAGE.about },
          { title: 'FAQs', path: PATH_PAGE.faqs },
          { title: 'Contact', path: PATH_PAGE.contact },
        ],
      },
    ]
  },
  {
    title_id: 3,
    title: 'Solutions',
    icon: <Iconify icon={'ic:round-grain'} {...ICON_SIZE} />,
    path: "#",
    children: [
      {
        subheader: 'Our Solutions',
        items: [
          { title: 'Asset Management', path: PATH_PAGE.assetmgmt },
          { title: 'Inventory Management', path: PATH_PAGE.inventmgmt },
          { title: 'Resources Management', path: PATH_PAGE.resrcmgmt },
          { title: 'Toolkits Management', path: PATH_PAGE.toolmgmt },
          { title: 'Facilities Management', path: PATH_PAGE.facimgmt },
          { title: 'Fleet Management', path: PATH_PAGE.fleetmgmt },
          { title: 'Residential Asset Management', path: PATH_PAGE.residensmgmt },
          { title: 'Livestock Management', path: PATH_PAGE.livestockmgmt },
          { title: 'Tools & Toolkit Management', path: PATH_PAGE.tltlkitmgmt },
          { title: 'ATC Hardware & Software Requirements', path: PATH_PAGE.hwswmgmt },
        ],
      },
    ]
  },
  {
    title_id: 4,
    title: 'Service',
    icon: <Iconify icon={'eva:book-open-fill'} {...ICON_SIZE} />,
    newTab: true,
    path: 'https://sandbsystems.com/',
  },
  {
    title_id: 5,
    title: 'Pricing',
    icon: <Iconify icon={'eva:book-open-fill'} {...ICON_SIZE} />,
    path: PATH_PAGE.pricing,
  },
  {
    title_id: 6,
    title: 'Reporting',
    icon: <Iconify icon={'eva:book-open-fill'} {...ICON_SIZE} />,
    path: PATH_PAGE.reporting,
  },
  {
    title_id: 6,
    title: 'Blog',
    icon: <Iconify icon={'eva:book-open-fill'} {...ICON_SIZE} />,
    path: PATH_PAGE.blog,
  },
  {
    title_id: 7,
    title: 'Login',
    icon: <Iconify icon={'eva:book-open-fill'} {...ICON_SIZE} />,
    path: PATH_PAGE.login,
  },


];

export default menuConfig;
